import { styled } from '@mui/material/styles';
import { AppBar as MuiAppBar, Box, Button, Typography, Menu, IconButton } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
export const StyledAppBar = styled(MuiAppBar)({
  backgroundColor: 'white',
  marginTop: 'auto',
});
export const NavContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'relative',
  width: '100%',
});
export const LogoContainer = styled(Box)({
  display: 'flex',
  alignContent: 'center',
  gap: '12px',
});
export const MobileMenuButton = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'flex',
  },
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));
export const MobileMenu = styled(Menu)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'block',
  },
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));
export const MenuItemText = styled(Typography)({
  textAlign: 'center',
});
export const LogoLink = styled(RouterLink)({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
});
export const LogoText = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
  },
  fontFamily: theme.typography.fontFamily,
  color: theme.palette.primary.main,
  fontWeight: 700,
  letterSpacing: '.1rem',
}));
export const NavLinksContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
  gap: '12px',
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  alignItems: 'center',
  justifyContent: 'center',
}));
export const NavButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ isActive, theme }) => ({
  marginTop: 2,
  marginBottom: 2,
  color: 'black',
  display: 'block',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 600,
  '&:hover': {
    color: theme.palette.primary.main,
    backgroundColor: 'transparent',
  },
  '&.MuiButton-root.Mui-selected': {
    color: theme.palette.primary.main,
  },
  ...(isActive && {
    color: theme.palette.primary.main,
    backgroundColor: `${theme.palette.primary.main}1A`,
  }),
}));
export const UserContainer = styled(Box)({
  flexGrow: 0,
});
export const UserMenu = styled(Menu)({
  marginTop: '45px',
});
export const UserIconButton = styled(IconButton)({
  padding: 0,
});
